export const Team = (props) => {
  return (
    <div id="team">
      <div className="container">
        <div className="section-title text-center">
          <h2>{props.title}</h2>
          <p>{props.paragraph}</p>
        </div>
        <div className="team-members">
          {props.list?.map((d, i) => (
            <div key={i} className="thumbnail">
              <img src={d.img} alt="..." className="team-img" />
              <div className="caption">
                <h4>{d.name}</h4>
                <p>{d.job}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
